export default {"src":"/_next/static/media/ReportingAndAnalytics.49f801b1.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};